import AREAS from './areas'
import CATEGORIA from './categoria'
import PRIORIDAD from './prioridad'

export class RegistroMovimientoArmaNotification {
  #notification

  constructor(notification) {
    this.#notification = notification
  }

  create(args) {
    const notification = new this.#notification()
    notification.responsable = args.responsable
    notification.afectado = args.afectado
    notification.titulo = AREAS.ARMERIA + ': Asignación de arma'
    notification.mensaje = `Se ha asignado el arma ${args.marcaArma} ${args.modeloArma} con matrícula ${args.matricula} y número económico ${args.noEconomico} al personal ${args.nombrePersonal}.`
    notification.prioridad = PRIORIDAD.MEDIA
    notification.categoria = CATEGORIA.INFORMATIVA

    return notification
  }
}
